import { ColumnDef } from "@tanstack/react-table";

import { HolidayList } from "./schema";

import { DataTableColumnHeader } from "./data-table-column-header";
import { DataTableRowActions } from "./data-table-row-actions";

export const columns: ColumnDef<HolidayList, any>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Index" />
    ),
    cell: ({ row }) => <div className="w-[80px]">{row.index + 1}</div>,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => <div>{row.getValue("name")}</div>,
    enableColumnFilter: true,
  },
  {
    accessorKey: "fromDate",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="From Date" />
    ),
    cell: ({ row }) => <div>{row.getValue("fromDate")}</div>,
    enableColumnFilter: true,
  },
  {
    accessorKey: "toDate",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="To Date" />
    ),
    cell: ({ row }) => <div>{row.getValue("toDate")}</div>,
    enableColumnFilter: true,
  },
  // {
  //   accessorKey: "email",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Email" />
  //   ),
  //   cell: ({ row }) => <div>{row.getValue("email")}</div>,
  // },
  // {
  //   accessorKey: "phone",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Phone" />
  //   ),
  //   cell: ({ row }) => <div>{row.getValue("phone")}</div>,
  // },

  {
    id: "actions",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];
